/** First-time walkthrough — how to use the portal assistant effectively. */

export const ASSISTANT_TOUR_STORAGE_KEY = "evp_asst_tour_v1_done";

export function isAssistantTourDone() {
  try {
    return localStorage.getItem(ASSISTANT_TOUR_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function markAssistantTourDone() {
  try {
    localStorage.setItem(ASSISTANT_TOUR_STORAGE_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function resetAssistantTour() {
  try {
    localStorage.removeItem(ASSISTANT_TOUR_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function getAssistantTourSteps(language) {
  const en = language === "en";
  if (en) {
    return [
      {
        id: "welcome",
        icon: "waving_hand",
        title: "Welcome",
        body: "I'm your eVerifPro assistant. Ask questions in plain English or French — I'll fetch live data from your portal and guide you step by step.",
      },
      {
        id: "chips",
        icon: "touch_app",
        title: "Quick suggestions",
        body: "Use the chips below the chat to try common tasks: portal summary, find a teacher, pending leave, assignment guide, and more.",
      },
      {
        id: "natural",
        icon: "chat",
        title: "Natural questions",
        body: "Examples: « How many teachers? », « Open leave requests », « Help on this page ». You don't need special commands.",
      },
      {
        id: "teachers",
        icon: "person_search",
        title: "Teachers & follow-ups",
        body: "Search by name or matricule. After a profile appears, ask follow-ups like « Is she assigned? » or « On leave? » without repeating the name.",
      },
      {
        id: "guides",
        icon: "route",
        title: "Walkthrough guides",
        body: "Say « assignment guide », « leave guide », or « teacher guide » for interactive step-by-step help on complex screens.",
      },
      {
        id: "actions",
        icon: "verified_user",
        title: "Confirmed actions",
        body: "To assign a teacher, activate a license, or submit leave — I'll show a preview first. Nothing is saved until you confirm.",
      },
    ];
  }

  return [
    {
      id: "welcome",
      icon: "waving_hand",
      title: "Bienvenue",
      body: "Je suis l'assistant eVerifPro. Posez vos questions en français ou en anglais — j'utilise les données live du portail et je vous guide pas à pas.",
    },
    {
      id: "chips",
      icon: "touch_app",
      title: "Suggestions rapides",
      body: "Les puces sous le chat proposent des actions fréquentes : résumé du portail, trouver une enseignante, congés en attente, guide affectation, etc.",
    },
    {
      id: "natural",
      icon: "chat",
      title: "Questions naturelles",
      body: "Exemples : « Combien d'enseignantes ? », « Ouvrir les congés », « Aide sur cette page ». Pas besoin de syntaxe particulière.",
    },
    {
      id: "teachers",
      icon: "person_search",
      title: "Enseignantes & suivi",
      body: "Recherchez par nom ou matricule. Après une fiche, enchaînez avec « Est-elle affectée ? » ou « En congé ? » sans retaper le nom.",
    },
    {
      id: "guides",
      icon: "route",
      title: "Guides pas à pas",
      body: "Dites « guide affectation », « guide congé » ou « guide enseignant » pour un accompagnement interactif sur les écrans complexes.",
    },
    {
      id: "actions",
      icon: "verified_user",
      title: "Actions confirmées",
      body: "Pour affecter, activer une licence ou soumettre un congé — un aperçu s'affiche d'abord. Rien n'est enregistré sans votre confirmation.",
    },
  ];
}
